export default {
    loaded: ({notifications}) => notifications.loaded,
    opened: ({notifications}) => notifications.opened,
    has_unread: ({notifications}) => notifications.has_unread,
    notifications: ({notifications}) => notifications.notifications,
    notifications_count: ({notifications}) => notifications.notifications_count
}